import apiFetch from '../apiFetch'

export default function (token, dossierId, lastAccessDate) {
  return apiFetch({
    endPoint: `dossier/sale/${dossierId}/printWarranty`,
    method: 'GET',
    parseBlobAndAssign: true,
    lastAccessDate,
    token: token
  })
}
